/**
 * @name ResponseHandlerService
 * @description Servicio para interceptar y manejar las respuestas del servidor
 * @author Ricardo Guerra
 */

import i18n from 'i18next';
import { SnackbarService } from '@services';

/**
 * Función que maneja los errores en las respuestas HTTP
 * @param {any} response
 */
const error = (response) => {
  let message = '';
  let error = response ? response.response : '';

  switch (error.status) {
    case 400:
      Object.keys(error.data).map((value) => {
        if (error.data[value] instanceof Array) {
          error.data[value].forEach((msg) => {
            return message += `${msg} `;
          });
        } else {
          return message += error.data[value];
        }
      });
      break;
    case 500:
      error.data.message ? message = error.data.message : message = i18n.t('HttpResponse.somethingWentWrong');
      break;
    case 404:
      return;
    case 405:
      message = i18n.t('HttpResponse.unauthorizedMessage');
      break;
    case 409:
      message = error.data;
      break;
    default: break;
  }

  // Network Error
  if (response === null) {
    return SnackbarService.error(i18n.t('GenericMessages.errorContactAdmin'));
  }

  if (message === '') {
    return SnackbarService.error(i18n.t('HttpResponse.error'));
  } else {
    return SnackbarService.error(message);
  }
};

/**
 * Función que maneja las respuestas HTTP exitosas
 * @param {any} response
 */
const success = (response) => {
  if (response.data && response.data.Mensaje) {
    return SnackbarService.success(response.data.Mensaje);
  }
  if (response.Mensaje) {
    return SnackbarService.success(response.Mensaje);
  } else {
    return SnackbarService.success(i18n.t('GenericMessages.success'));
  }
};

export const ResponseHandlerService = {
  error,
  success
};